export default {
  methods: {
    latestScores(patient) {
      if (!patient || !patient.assessmentScores) {
        return [];
      }
      return patient.assessmentScores.filter(s => s.latest);
    }
  }
};
